import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Row,
  Spinner,
  OverlayTrigger,
  Modal,
  Container,
  Badge,
  Table,
} from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { TailSpin } from "react-loader-spinner";
import { Form, useNavigate, useParams } from "react-router-dom";
import Tooltip from "react-bootstrap/Tooltip";
import {
  faBuildingColumns,
  faCamera,
  faPhone,
  faRoad,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EG_Admin_Icon from "assets/icons/Subtraction.png";
import emailIcon from "assets/icons/email.png";
import End_User_Icon from "assets/icons/end-user.png";
import info from "assets/icons/info.png";
import EG_Consultant_Icon from "assets/icons/user-tie.png";
import Internal_Admin_Icon from "assets/icons/verified.png";
import API_User_Icon from "assets/icons/verified.png";
import {
  BRANCH_ADMIN,
  BRANCH_CONSULTANT,
  END_USER,
} from "common/constants/constants";
import { PRODUCTS, VDS_MANAGEMENT } from "common/constants/permissionKeys";
import { CommonButton } from "components/common/button/Button";
import Loader from "components/common/loader/Loader";
import NestedCheckbox from "components/common/nestedCheckbox/NestedCheckbox";
import { formatPermissions } from "utils/Utils";
import { handleClaimsParentLevel } from "utils/Utils";
import { claimsAnalyse } from "utils/Utils";

import { updateProfilePicture } from "services/UserAccountManagementServices";
import { setResendPasswordLink } from "services/UserAccountManagementServices";
import {
  getUserById,
  getUserOrganizationDetailById,
  downloadOrganizationDetail,
  resetCalculationCounter,
  getSubscriptionsInfo,
} from "services/UserManagementServices";
import {
  getUserPermissions,
  getOrganization,
} from "services/UserManagementServices";
import { updateUserClaims } from "services/UserManagementServices";
import { fetchUsersProfilePicture } from "services/UserManagementServices";
import { getBranchProducts } from "services/branchServices";
import "./UserDetail.scss";
import { useTranslation } from "react-i18next";
import ResendPasswordNotification from "./ResendPasswordNotification";
import { removeCredentials } from "services/UserManagementServices";
import { resendCredentials } from "services/UserManagementServices";
import { getGeccoLogin } from "common/utils/utilities";
import Plus from "assets/icons/Plus";
import ConfirmationModal from "./ConfirmationModal";
import { dateParser } from "utils/Utils";

const UserDetail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [permissionsList, setPermissionsList] = useState([]);
  const [disable, setDisable] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [organizationData, setOrganizationData] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [userProfilePicture, setUserProfilePicture] = useState({
    url: null,
    isFetching: false,
  });
  const [buttonClicked, setButtonClicked] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showResendPasswordNotification, setShowResendPasswordNotification] =
    useState(false);
  const [companyQuestionaireData, setCompanyQuestionaireData] = useState([]);
  const [isCounterConfirmaitonModalOpen, setIsCounterConfirmaitonModalOpen] =
    useState(false);
  let roles = JSON.parse(localStorage.getItem("userRole"))?.roleName;

  const {
    firstName = "-",
    lastName = "-",
    email = "",
    claims = [],
    role = {},
    emailConfirmed = false,
    branchInfo,
  } = userDetails;
  const rolesInfo = {
    End_User: {
      imgSrc: End_User_Icon,
      discription: t("end-user-description"),
      bgColor: "#4CE228",
      name: "#EU",
    },
    EG_Consultant: {
      imgSrc: EG_Consultant_Icon,
      discription: t("eg-consultant-description"),
      bgColor: "#A32C48",
      name: "#EC",
    },
    EG_Admin: {
      imgSrc: EG_Admin_Icon,
      discription: t("eg-admin-description"),
      bgColor: "#FF3B68",
      name: "#EA",
    },
    Internal_Admin: {
      imgSrc: Internal_Admin_Icon,
      notes: t("internal-admin-notes"),
      discription: t("internal-admin-description"),
      bgColor: "#3B61FF",
      name: "#IA",
    },
    Api_User: {
      imgSrc: API_User_Icon,
      notes: t("api-user-notes"),
      discription: t("api-user-description"),
      bgColor: "#3B61FF",
      name: "#AU",
    },
  };
  const currentRoleInfo =
    rolesInfo[userDetails?.role?.roleTranslatedValue.split(" ").join("_")] ||
    {};
  let { id } = useParams();
  useEffect(() => {
    getUserDetails();
    getUserCompanyDetails();
    getPaymentDetails();
    if (roles == "#EC" || roles == "#EA") {
      companyQuestionaireDetails();
    }
  }, [refresh, location.pathname]);

  const getActiveUserPermissions = (claims, permissions) => {
    for (let i = 0; i < permissions.length; i++) {
      const elementI = permissions[i];
      if (claims?.includes(elementI.claimKey)) {
        elementI.value = true;
      }
      if (elementI.hasOwnProperty("sub"))
        getActiveUserPermissions(claims, elementI.sub);
    }
  };
  const getUserCompanyDetails = async () => {
    let result = await getUserOrganizationDetailById(id);
    if (result) {
      setOrganizationData(result?.payLoad[0]);
    }
  };
  const getPaymentDetails = async () => {
    let result = await getSubscriptionsInfo(id);
    if (result) {
      debugger;
      setSubscriptionData(result?.payLoad);
    }
  };

  const downloadPdf = async (questionnaireId) => {
    let response = await downloadOrganizationDetail(id, questionnaireId);
    const result = { status: 200 };
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "PDF-Bericht" + ".pdf");
    document.body.appendChild(link);
    link.click();
    return result;
  };
  const filterECEUPermissions = (
    rawPermissions,
    branchProducts,
    assignedProductToUser,
    userRoleName
  ) => {
    if (["#EC", "#EU"].includes(userRoleName)) {
      rawPermissions =
        rawPermissions &&
        rawPermissions?.filter(
          (item) =>
            item.applicationKey == null ||
            item.applicationKey === "#VdsManagement" ||
            (assignedProductToUser.length > 0
              ? assignedProductToUser.includes(item.applicationKey)
              : branchProducts.includes(item.applicationKey))
        );
      return rawPermissions;
    }
  };
  const getUserDetails = async () => {
    let branchProducts = [];
    let result = await getUserById(id);
    if (result?.success) {
      setUserDetails(result?.payLoad);
      const assignedProductToUser = result?.payLoad?.applicationKeys;
      const userRoleName = result?.payLoad?.role?.roleName;
      await handleProfilePicture(result);
      branchProducts = await handleBranchDetails(result);
      let resultPermissions = await getUserPermissions();
      if (resultPermissions?.success) {
        setIsLoading(false);
        let rawPermissions = [...resultPermissions.payLoad];

        rawPermissions = filterECEUPermissions(
          rawPermissions,
          branchProducts,
          assignedProductToUser,
          userRoleName
        );
        rawPermissions = rawPermissions.filter(
          (item) => item.type === userRoleName
        );
        rawPermissions = disabledPermissions(
          rawPermissions,
          assignedProductToUser,
          userRoleName
        );
        let formatedPermissions = formatPermissions(rawPermissions);
        let activeClaims = [];
        for (let i = 0; i < result?.payLoad?.claims.length; i++) {
          const elementI = result?.payLoad?.claims[i];
          activeClaims.push(elementI.claimKey);
        }

        getActiveUserPermissions(activeClaims, formatedPermissions);

        let analysedClaims = claimsAnalyse(formatedPermissions);
        setPermissionsList([...analysedClaims]);
      } else {
        toast.error(t("err-get-permission"));
      }
    } else {
      toast.error(t("err-get-user-data"));
    }
  };
  const handleProfilePicture = async (result) => {
    if (result?.payLoad?.profilePicture) {
      setUserProfilePicture({ ...userProfilePicture, isFetching: true });
      let result = await fetchUsersProfilePicture(id);
      if (result.status === 200)
        setUserProfilePicture({
          url: URL.createObjectURL(result.data),
          isFetching: false,
        });
    }
  };
  const handleBranchDetails = async (result) => {
    let branchProducts = [];
    if (result?.payLoad?.branchInfo) {
      const { branchId, bankId, bankGroupId } =
        result?.payLoad?.branchInfo || {};
      let pathIds = { branchId, bankId, bankgroupsId: bankGroupId };
      let branchProductsResult = await getBranchProducts(pathIds);
      if (branchProductsResult.success) {
        branchProductsResult.payLoad.forEach((product) => {
          if (product.assigned === "Active") {
            branchProducts = [...branchProducts, product.productKey];
          }
        });
      }
    }
    return branchProducts;
  };
  const disabledPermissions = (permissions, asspignedProduct, userRoleName) => {
    let products = [];
    if ([BRANCH_ADMIN].includes(userRoleName)) {
      products = [VDS_MANAGEMENT];
    } else if ([BRANCH_CONSULTANT].includes(userRoleName)) {
      products = [...asspignedProduct, VDS_MANAGEMENT, PRODUCTS];
    } else if ([END_USER].includes(userRoleName)) {
      products = asspignedProduct;
    }
    return permissions.filter((item) =>
      products.length > 0 && products.includes(item.claimKey)
        ? (item.disabledProduct = true)
        : item
    );
  };

  const handleChange = (event, item) => {
    let list = handleClaimsParentLevel(event, item, permissionsList);
    setPermissionsList([...list]);
    setDisable(false);
  };

  let totalClaims = [];
  const getAllActiveClaims = (list) => {
    list?.forEach((child) => {
      if (child.value) totalClaims.push(child.claimId);
      if (child.hasOwnProperty("sub")) getAllActiveClaims(child.sub);
    });
  };

  const handleSubmit = async () => {
    getAllActiveClaims(permissionsList);
    let obj = {
      claims: totalClaims,
    };
    setLoading(true);
    let result = await updateUserClaims(id, obj);
    if (result?.success) {
      setLoading(false);
      setDisable(false);
    } else {
      setLoading(false);
      setDisable(false);
      toast.error(t("err-put-claims"));
    }
  };
  const handleRefresh = () => setRefresh((pre) => !pre);
  const handleImageChange = async (file) => {
    let form_data = new FormData();
    const payLoad = {
      userId: id,
      profilePicture: file,
    };
    Object.keys(payLoad).forEach((key) =>
      form_data.append(`${key}`, payLoad[key])
    );

    let response = await updateProfilePicture(form_data);
    if (!response.success) {
      toast.error(t("err-put-profile"));
    } else handleRefresh();
  };
  const handleResendLink = async (id) => {
    setIsFetching(true);
    await setResendPasswordLink(id);
    setIsFetching(false);
    setShowResendPasswordNotification(true);
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileName = file?.name;
      const extension = fileName?.split(".")?.pop()?.toLowerCase();
      const isSupported = ["jpg", "png", "jpeg"].includes(extension);
      if (isSupported) {
        handleImageChange(event.target.files[0]);
        event.target.value = "";
      } else {
        toast.error(t("err-img-format"));
      }
    }
  };
  const getConsultantName = () => {
    let displayedValue;

    if (userDetails?.role?.roleName === "#EU") {
      displayedValue = userDetails?.consultantName || "--";
    } else if (userDetails?.role?.roleName === "#EA") {
      displayedValue = userDetails?.invitedBy || "--";
    } else {
      displayedValue = branchInfo?.branchName || "--";
    }
    return displayedValue;
  };
  const getProfilePicture = () => {
    return (
      (userProfilePicture.isFetching && (
        <Spinner animation="border" size="sm" />
      )) ||
      (userProfilePicture.url && (
        <img alt="not found" src={userProfilePicture.url} />
      )) || (
        <span>
          {`${(firstName && firstName[0]) || "-"}${
            (lastName && lastName[0]) || "-"
          }`}
        </span>
      )
    );
  };
  const handleCounterReset = async () => {
    let result = await resetCalculationCounter(id);
    if (result?.payLoad) {
      setIsCounterConfirmaitonModalOpen(false);
      handleRefresh();
      toast?.success(t("counter-reset-success"));
    } else {
      toast?.error(t("counter-reset-error"));
    }
  };
  const renderCompanyDetails = () => {
    if (userDetails?.role?.roleName === "#EU") {
      if (userDetails?.applicationKeys?.includes("#Gecco")) {
        return (
          <div className="konto-form">
            <span className="pt-4  d-inline-block" style={{ width: "70%" }}>
              <label className="labels">{t("companyName")}</label>
              <br></br>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="name-tooltip">{organizationData?.name}</Tooltip>
                }
              >
                <input
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                  disabled={true}
                  value={organizationData?.name}
                ></input>
              </OverlayTrigger>
            </span>

            <span
              style={{ marginLeft: "5%", width: "25%" }}
              className="pt-4  d-inline-block"
            >
              <label className="labels">{t("street")}</label>
              <br></br>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="name-tooltip">{organizationData?.city}</Tooltip>
                }
              >
                <input
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                  disabled={true}
                  value={organizationData?.city}
                ></input>
              </OverlayTrigger>
            </span>
            <br />

            <span className="pt-4  d-inline-block" style={{ width: "25%" }}>
              <label className="labels">{t("postalCode")}</label>
              <br></br>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="name-tooltip">
                    {organizationData?.postalCode}
                  </Tooltip>
                }
              >
                <input
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                  disabled={true}
                  value={organizationData?.postalCode}
                ></input>
              </OverlayTrigger>
            </span>

            <span
              style={{ marginLeft: "5%", width: "70%" }}
              className="pt-4  d-inline-block"
            >
              <label className="labels">{t("address")}</label>
              <br></br>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="name-tooltip">
                    {organizationData?.address1}
                  </Tooltip>
                }
              >
                <input
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                  disabled={true}
                  value={organizationData?.address1}
                ></input>
              </OverlayTrigger>
            </span>
            <br />
          </div>
        );
      }
    }
  };
  const handleResendCreds = async (id) => {
    setLoading(true);
    let result = await resendCredentials(id);
    if (result?.success) {
      setShowModal(false);
      setLoading(false);

      handleRefresh();
    } else {
      setLoading(false);
      toast?.error(t("genral-error"));
    }
  };
  const handleRemoveCreds = async (id) => {
    setLoading(true);
    let result = await removeCredentials(id);
    if (result?.success) {
      handleRefresh();
      setShowModal(false);

      setLoading(false);
    } else {
      toast?.error(t("genral-error"));
      setLoading(false);
    }
  };
  const renderSecretDetails = () => {
    return (
      <>
        <div className="d-flex flex-column gap-2 mt-3">
          {userDetails?.clientId &&
            userDetails?.clientId !==
              "00000000-0000-0000-0000-000000000000" && (
              <p>Client ID - {userDetails?.clientId}</p>
            )}
          {userDetails?.clientSecret && (
            <p>Client Secret - {userDetails?.clientSecret}</p>
          )}
        </div>
        <div className="d-flex gap-3">
          {userDetails?.clientId &&
            userDetails?.clientId !==
              "00000000-0000-0000-0000-000000000000" && (
              <CommonButton
                title={
                  loading ? (
                    <TailSpin
                      height="20"
                      width="20"
                      color="#ffff"
                      radius="1"
                      visible={true}
                    />
                  ) : (
                    <p className="fw-2 m-0">{t("remove-creds")}</p>
                  )
                }
                borderRadius="5px"
                border="none"
                padding="8px 15px"
                margin="20px 0 0 0"
                click={() => {
                  setShowModal(true);

                  setButtonClicked({
                    name: "remove",
                    id: id,
                  });
                }}
                maxHeight="38px"
              />
            )}
          {!userDetails?.clientId ||
            (userDetails?.clientId ===
              "00000000-0000-0000-0000-000000000000" && (
              <CommonButton
                title={
                  loading ? (
                    <TailSpin
                      height="20"
                      width="20"
                      color="#ffff"
                      radius="1"
                      visible={true}
                    />
                  ) : (
                    <p className="fw-2 m-0">{t("resend-creds")}</p>
                  )
                }
                borderRadius="5px"
                border="none"
                padding="8px 8px"
                margin="20px 0 0 0"
                click={() => {
                  setShowModal(true);
                  setButtonClicked({
                    name: "resend",
                    id: id,
                  });
                }}
                maxHeight="38px"
              />
            ))}
        </div>
      </>
    );
  };
  const renderConsultantEmail = () => {
    const email =
      userDetails?.role?.roleName === "#EU"
        ? userDetails?.consultantEmail
          ? userDetails?.consultantEmail
          : branchInfo?.branchEmail
        : "--";
    return (
      <p className="ms-4 mb-0 flex-grow-1">
        <span className="pt-2  d-inline-block">
          <img src={emailIcon} className="me-2" />
          {email}
        </span>
      </p>
    );
  };
  const renderConsultantPhone = () => {
    const phoneNumber =
      userDetails?.role?.roleName === "#EU"
        ? userDetails?.consultantPhoneNumber
          ? userDetails?.consultantPhoneNumber
          : branchInfo?.branchPhoneNumber
        : "--";
    return (
      <p className="ms-4 mb-0 flex-grow-1">
        <span className="pt-2  d-inline-block">
          <FontAwesomeIcon
            icon={faPhone}
            size="1x"
            className="me-2"
            color="#000"
          />
          {phoneNumber}
        </span>
      </p>
    );
  };

  useEffect(() => {
    if (roles == "#EC" || roles == "#EA") {
      companyQuestionaireDetails();
    }
  }, []);

  const companyQuestionaireDetails = async () => {
    let result = await getOrganization(id);
    if (result) {
      setCompanyQuestionaireData(result?.payLoad?.items);
    }
  };

  return (
    <>
      <Toaster />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="eg-user claims">
          <div className="custom-breadcrumbs mx-5 px-2">
            <span
              className="breadcrumbs-item "
              onClick={() => {
                navigate("/user-management");
              }}
            >
              {t("user-management")}
            </span>
            <span className="breadcrumbs-item ">
              <p>
                {firstName} {lastName}
              </p>
            </span>
          </div>
          <div className="d-flex flex-wrap">
            <Col lg={6} sm={12}>
              <div className="role">
                <h3>{t("role")}</h3>
                <img src={currentRoleInfo?.imgSrc} />
                <span className="ms-2">{t(currentRoleInfo?.name)}</span>
                <p className="paragraph">{currentRoleInfo?.discription}</p>
                {currentRoleInfo?.highlight && (
                  <p className="line-text">{currentRoleInfo?.highlight}</p>
                )}
                {currentRoleInfo?.notes && (
                  <Card className="info-card flex-row">
                    <img src={info} width={19} height={19} />
                    <p className="ms-2 mb-0">{currentRoleInfo?.notes}</p>
                  </Card>
                )}
                <h3 className="mt-4">{t("allowed-permission")}</h3>

                <NestedCheckbox
                  permissionsList={permissionsList}
                  handleChange={handleChange}
                />

                <button
                  className={`${
                    disable ? "opacity-50" : ""
                  } update-btn mb-5 mt-3 w-auto`}
                  style={{ textTransform: "none" }}
                  onClick={handleSubmit}
                  disabled={disable}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      {t("update-claims")}
                    </>
                  ) : (
                    t("update-claims")
                  )}
                </button>
                {userDetails?.role?.roleName === "#EU" &&
                  userDetails?.applicationKeys?.includes("#Gecco") && (
                    <button
                      className={` ${
                        !organizationData?.isCalculationCanReset
                          ? "opacity-50"
                          : ""
                      } counter-reset-button  mx-4 mb-5 mt-3 w-auto px-3`}
                      onClick={() => setIsCounterConfirmaitonModalOpen(true)}
                      disabled={!organizationData?.isCalculationCanReset}
                      style={{ textTransform: "none" }}
                    >
                      <Plus style={{ fill: "#6200ee" }} width={15} />
                      &nbsp; &nbsp; Basic-Berechnung hinzufügen (
                      {organizationData?.isCalculationCanReset ? 0 : 1})
                    </button>
                  )}
              </div>

              <div className="major_document role">
                <div className="heading_wrapper">
                  <h3 className="document_heading">{t("major-documents")}</h3>
                  <span className="heading-detail">{t("about-versions")}</span>
                </div>
                <div className="company-list">
                  {companyQuestionaireData?.length > 0 &&
                    companyQuestionaireData?.map((company, index) => {
                      return (
                        <div className="company_wrapper" key={index}>
                          <div style={{ flex: "0 0 32px" }}>
                            <img src="/assets/icons/eq.svg" alt="icon" />
                          </div>
                          <div
                            style={{ flex: "0 0 215px" }}
                            className="company-name"
                          >
                            {company?.name}
                          </div>
                          <div style={{ flex: "0 0 25px", cursor: "pointer" }}>
                            <img
                              src="/assets/icons/download.svg"
                              alt="icon"
                              onClick={() => {
                                downloadPdf(company?.esgQuestionnaireId);
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </Col>
            <Col lg={6} sm={12}>
              <div className="container">
                <h3>{t("account")}</h3>
                <Card className="acc-card flex-row flex-wrap">
                  <div
                    className="circle-icon col-md-2"
                    style={{
                      background: userProfilePicture.url
                        ? "transparent"
                        : "#4CE228",
                    }}
                  >
                    {getProfilePicture()}
                    <div className="overlay">
                      <FontAwesomeIcon
                        icon={faCamera}
                        size="2x"
                        color="white"
                      />
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={onImageChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-10">
                    <p className="ms-4 flex-grow-1">
                      {`${firstName || "--"} ${lastName || "--"}`}
                      <br />
                      <span className="pt-4  d-inline-block">
                        <img src={emailIcon} className="me-2" />
                        {email}
                      </span>
                      <br />
                      {userDetails?.role?.roleName === "#EU" &&
                        organizationData?.paymentPlanName &&
                        userDetails?.applicationKeys?.includes("#Gecco") && (
                          <>
                            <br />
                            <span
                              style={{ fontSize: "16px", fontWeight: "700" }}
                            >
                              {t("current-subscription-model")}: &nbsp;&nbsp;
                              <span
                                className={`badge rounded-pill px-3 py-2 cursor-pointer ${
                                  organizationData?.paymentPlanName ===
                                  "Basic Free"
                                    ? "badge-basic"
                                    : organizationData?.paymentPlanName ==
                                      "One Time"
                                    ? "badge-one-time"
                                    : "badge-default"
                                }`}
                              >
                                {t(
                                  `PaymentPlans.${organizationData?.paymentPlanName}`
                                )}
                              </span>
                              {/* <Badge
                                bg={undefined}
                                className={`px-3 py-2 cursor-pointer rounded-pill ${
                                  organizationData?.paymentPlanName ===
                                  "Basic Free"
                                    ? "badge-basic"
                                    : organizationData?.paymentPlanName ===
                                      "One Time"
                                    ? "badge-one-time"
                                    : "badge-default"
                                }`}
                              >
                                {t(
                                  `PaymentPlans.${organizationData?.paymentPlanName}`
                                )}
                              </Badge> */}
                            </span>
                          </>
                        )}
                      {currentRoleInfo?.name === "#AU" && renderSecretDetails()}
                      <br></br> {renderCompanyDetails()}
                      {currentRoleInfo?.name !== "#AU" && (
                        <>
                          {!emailConfirmed && (
                            <CommonButton
                              title={
                                isFetching ? (
                                  <TailSpin
                                    height="20"
                                    width="20"
                                    color="#ffff"
                                    radius="1"
                                    visible={true}
                                  />
                                ) : (
                                  <p className="fw-2 m-0">
                                    {t("resend-password")}
                                  </p>
                                )
                              }
                              borderRadius="5px"
                              border="none"
                              padding="8px 15px"
                              margin="20px 0 0 0"
                              click={() => handleResendLink(id)}
                              disabled={isFetching}
                              maxHeight="38px"
                            />
                          )}
                        </>
                      )}
                    </p>
                  </div>
                  <br />
                </Card>
              </div>
              {currentRoleInfo?.name !== "#AU" && (
                <div className="container mt-3">
                  <h3>{t("branch-details")}</h3>
                  <Card className="acc-card flex-row flex-wrap mb-2">
                    <div className="circle-icon">
                      <img
                        alt="not found"
                        src={`/assets/icons/Branch.svg`}
                        style={{ width: "inherit", height: "30px" }}
                      />
                    </div>
                    <div>
                      <p className="ms-4 mb-0 flex-grow-1">
                        <span className="pt-2  d-inline-block">
                          {getConsultantName()}
                        </span>
                      </p>
                      <p className="ms-4 mb-0 flex-grow-1">
                        <span className="pt-2  d-inline-block">
                          <FontAwesomeIcon
                            icon={faBuildingColumns}
                            size="1x"
                            className="me-2"
                            color="#000"
                          />
                          {`${branchInfo?.bankName || "--"}`}
                        </span>
                      </p>
                      {renderConsultantEmail()}
                      {renderConsultantPhone()}
                    </div>
                  </Card>
                </div>
              )}
              {userDetails?.role?.roleName === "#EU" &&
                userDetails?.applicationKeys?.includes("#Gecco") && (
                  <div className="container mt-3">
                    <h3>{t("Buchungen")}</h3>
                    <Card className="px-4 mb-2">
                      <></>
                      <Table responsive bordered hover className="mt-3 ">
                        <thead>
                          <tr className="border-top-0">
                            <th className="border-start-0 border-end-0 tableHeadSection ">
                              Gebuchte Pakete
                            </th>
                            <th className="border-start-0 border-end-0 tableHeadSection">
                              Buchungsdatum
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {subscriptionData?.invoiceDetails?.map(
                            (item, index) => (
                              <tr key={index}>
                                <td className="border-start-0 border-end-0 py-3 tableDataSection">
                                  <span
                                    className={`badge rounded-pill px-3 py-2 cursor-pointer ${
                                      item?.paymentPlan === "Basic Free"
                                        ? "badge-basic"
                                        : item?.paymentPlan === "One Time"
                                        ? "badge-one-time"
                                        : "badge-default"
                                    }`}
                                  >
                                    {t(`PaymentPlans.${item?.paymentPlan}`)}
                                  </span>
                                  {/* <Badge
                                    bg={undefined}
                                    className={`px-3 py-2 cursor-pointer badge rounded-pill ${
                                      item?.paymentPlan === "Basic Free"
                                        ? "badge-basic"
                                        : item?.paymentPlan === "One Time"
                                        ? "badge-one-time"
                                        : "badge-default"
                                    }`}
                                  >
                                    {t(`PaymentPlans.${item?.paymentPlan}`)}
                                  </Badge> */}
                                </td>
                                <td className="border-start-0 border-end-0 tableDataSection ">
                                  {dateParser(item.fromDate)}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </Table>
                    </Card>
                  </div>
                )}
            </Col>
          </div>
        </div>
      )}
      <ResendPasswordNotification
        isOpen={showResendPasswordNotification}
        onClose={() => {
          setShowResendPasswordNotification(false);
        }}
      />
      <Modal
        show={showModal}
        size="sm"
        centered
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Container fluid>
          <Modal.Body
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              onClick={() => {
                setShowModal(false);
              }}
              style={{
                position: "absolute",
                top: 10,
                right: 20,
                cursor: "pointer",
              }}
            >
              <p>X</p>
            </div>
            <p style={{ paddingTop: "5%" }}>
              {buttonClicked?.name === "remove"
                ? t("remove-creds-message")
                : t("resend-creds-message")}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex gap-5">
              <CommonButton
                title={<p className="fw-2 m-0">{t("cancel")}</p>}
                borderRadius="5px"
                border="none"
                padding="8px 15px"
                margin="20px 0 0 0"
                click={() => {
                  setShowModal(false);
                }}
                maxHeight="38px"
              />
              {buttonClicked?.name === "remove" ? (
                <CommonButton
                  title={
                    loading ? (
                      <TailSpin
                        height="20"
                        width="20"
                        color="#ffff"
                        radius="1"
                        visible={true}
                      />
                    ) : (
                      <p className="fw-2 m-0">{t("remove-creds")}</p>
                    )
                  }
                  borderRadius="5px"
                  border="none"
                  padding="8px 15px"
                  margin="20px 0 0 0"
                  click={() => {
                    setShowModal(true);

                    handleRemoveCreds(buttonClicked?.id);
                  }}
                  maxHeight="38px"
                />
              ) : (
                <CommonButton
                  title={
                    loading ? (
                      <TailSpin
                        height="20"
                        width="20"
                        color="#ffff"
                        radius="1"
                        visible={true}
                      />
                    ) : (
                      <p className="fw-2 m-0">{t("resend-creds")}</p>
                    )
                  }
                  borderRadius="5px"
                  border="none"
                  padding="8px 15px"
                  margin="20px 0 0 0"
                  click={() => {
                    handleResendCreds(buttonClicked?.id);
                  }}
                  maxHeight="38px"
                />
              )}
            </div>
          </Modal.Footer>
        </Container>
      </Modal>
      <ConfirmationModal
        isOpen={isCounterConfirmaitonModalOpen}
        onClose={() => setIsCounterConfirmaitonModalOpen(false)}
        onConfirmation={handleCounterReset}
      />
    </>
  );
};

export default UserDetail;
